import styled from 'styled-components';

import { InputContainer } from '@components/Input';

export const Span = styled.span`
  &:before {
    content: ' ';
    white-space: pre;
  }
  @media only screen and (max-width: 425px) {
    &::before {
      content: '';
    }
    line-height: 1.57;
  }
`;
export const NoteWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.D10};
  padding: 0 40px 0 40px;
  width: 100%;
`;
export const Title = styled.div`
  text-align: center;
  padding-top: 14px;
  padding-bottom: 8px;
`;
export const Description = styled.div`
  text-align: center;
  padding-bottom: 21px;
`;
export const Content = styled.div`
  margin: 40px 0 0;
  font-size: 16px;
  line-height: 1.56;
  color: ${(p) => p.theme.palette.darkGray};
  ${(p) => p.theme.mediaQueries.PHONE} {
    display: flex;
    flex-direction: column;
    svg {
      align-self: center;
    }
    row-gap: 20px;
    margin-top: 25px;
  }
`;

export const Section = styled.section`
  margin: 32px 0 40px;
  display: flex;
  button {
    height: unset;
    width: 148px;
    font-weight: bold;
  }
  column-gap: 20px;
  ${InputContainer} {
    flex: 1;
  }
  ${(p) => p.theme.mediaQueries.PHONE} {
    flex-direction: column;
    row-gap: 20px;
    margin: 0px 0px;
    &:last-child {
      margin-bottom: 20px;
    }
    ${InputContainer} {
      height: 68px;
      flex: unset;
    }
    button {
      height: 68px;
      width: 100%;
    }
  }
`;
export const Paragraph = styled.p`
  font-size: 14px;
  line-height: 1.57;
  margin: 0;
  color: ${(p) => p.theme.palette.darkGrey};
  ${(p) => p.theme.mediaQueries.PHONE} {
    text-align: center;
  }
`;

export const Bold = styled.span`
  font-weight: bold;
`;
